module.exports = __webpack_public_path__ + "img/lockicon.0a0c378c.svg";